import { RouteConfig } from 'vue-router'

export default [
  {
    path: '/junior-refund/modes',
    name: 'junior_refund_modes',
    component: () => import('../../views/juniorRefund/Modes.vue'),
    meta: {
      title: '未成年人退款',
    },
  },

  {
    path: '/junior-refund/apple-offical',
    name: 'junior_refund_modes_apple_offical',
    component: () => import('../../views/juniorRefund/AppleOffical.vue'),
    meta: {
      title: '如何使用Apple官方退款',
    },
  },
  {
    path: '/junior-refund/step1',
    name: 'junior_refund_step1',
    component: () => import('../../views/juniorRefund/Step1.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '选择订单',
    },
  },
  {
    path: '/junior-refund/step2',
    name: 'junior_refund_step2',
    component: () => import('../../views/juniorRefund/Step2.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '未成年人充值退款申请',
    },
  },
  {
    path: '/junior-refund/step3',
    name: 'junior_refund_step3',
    component: () => import('../../views/juniorRefund/Step3.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '未成年人充值退款申请',
    },
  },
  {
    path: '/junior-refund/realtion',
    name: 'junior_refund_relation',
    component: () => import('../../views/juniorRefund/Relation.vue'),
    props: (_route) => ({ ..._route.query, ..._route.params }),
    meta: {
      title: '上传监护人必要信息证明',
    },
  },
  {
    path: '/junior-refund/realtion-intro',
    name: 'junior_refund_relation_intro',
    component: () => import('../../views/juniorRefund/RelationIntro.vue'),
    meta: {
      title: '退款收集用户信息的情况说明',
    },
  },
  {
    path: '/junior-refund/refund-introduce',
    name: 'junior_refund_refund_introduce',
    component: () => import('../../views/juniorRefund/RefundIntroduce.vue'),
    meta: {
      title: '退款须知',
    },
  },
  {
    path: '/junior-refund/apple-order-info',
    name: 'junior_refund_apple_order_info',
    component: () => import('../../views/juniorRefund/AppleOrderInfo.vue'),
    meta: {
      title: '如何获取Apple订单信息',
    },
  },
  {
    path: '/junior-refund/ali-refund-intro',
    name: 'junior_refund_ali_refund_intro',
    component: () => import('../../views/juniorRefund/AliRefundIntro.vue'),
    meta: {
      title: '如何获取支付宝账户信息',
    },
  },
  {
    path: '/junior-refund/sports-data-report',
    name: 'junior_refund_sports_data_report',
    component: () => import('../../views/juniorRefund/SportsDataReport.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '运动数据报告',
    },
  },
  {
    path: '/junior-refund/wx-entry',
    name: 'junior_refund_wx_entry',
    component: () => import('../../views/juniorRefund/WxEntry.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '天天跳绳人工退款专用链接',
    },
  },
  {
    path: '/junior-refund/wx-end',
    name: 'junior_refund_wx_end',
    component: () => import('../../views/juniorRefund/WxEnd.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '天天跳绳人工退款专用链接',
    },
  },
  {
    path: '/junior-refund/wx-step2',
    name: 'junior_refund_refund_wx_step2',
    component: () => import('../../views/juniorRefund/WxStep2.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '退款须知',
    },
  },
] as RouteConfig[]
